import type { ImportResponseType } from '../../shared/ColumnSelectPro/currentImport';

export const importFileTypeItems = [
    { id: '', label: '<wybierz>' },
    { id: 'locations', label: 'Punkty (sklepy, magazyny, itp)' },
    { id: 'connections', label: 'Połączenia między punktami (trasy)' },
];

export const importMethodTypeItems = [
    { id: 'upsert', label: 'Dodanie/aktualizacja' },
    { id: 'overwrite', label: 'Zastąpienie wszystkich' },
];

export type ImportMethodType = 'upsert' | 'overwrite';

export class Import {
    private import: ImportResponseType;

    constructor(_import: ImportResponseType) {
        this.import = _import;
    }

    public inProgress() {
        return this.isStarted() && !this.isCompleted();
    }

    public isStarted() {
        if (this.import) {
            return this.import.geocoding_started !== null;
        }
        throw new Error('Import not set');
    }

    public isCompleted() {
        if (this.import) {
            return this.import.geocode_completed && this.import.jobs_created;
        }
        throw new Error('Import not set');
    }

    public getId() {
        if (this.import) {
            return this.import.id;
        }
        throw new Error('Import not set');
    }
}
